import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "buttonText"]
  static values = {
    ticketId: String
  }

  connect() {
    // Listen for resolve ticket event
    this.handleResolveTicket = this.handleResolveTicket.bind(this)
    window.addEventListener('resolve-ticket', this.handleResolveTicket)
  }

  disconnect() {
    window.removeEventListener('resolve-ticket', this.handleResolveTicket)
  }

  handleResolveTicket(event) {
    if (event.detail.ticketId == this.ticketIdValue) {
      this.toggle({ stopPropagation: () => {} })
    }
  }

  toggle(event) {
    event.stopPropagation()
    
    const isExpanded = !this.formTarget.classList.contains('hidden')
    
    // Encontrar el card padre (para habilitar/deshabilitar scroll)
    const zoomedCard = this.element.closest('.zoomed')
    const isMobile = window.innerWidth < 768
    
    if (isExpanded) {
      // Contraer
      this.formTarget.classList.add('hidden')
      this.buttonTextTarget.textContent = 'Resolver'
      
      // Verificar si el contenido sin el formulario sigue necesitando scroll
      if (zoomedCard && isMobile) {
        // Esperar a que el DOM se actualice después de ocultar el formulario
        requestAnimationFrame(() => {
          if (zoomedCard.scrollHeight > zoomedCard.clientHeight) {
            // El contenido del ticket aún excede el viewport, mantener scroll
            zoomedCard.style.setProperty('overflow-y', 'auto', 'important')
          } else {
            // El contenido cabe en el viewport, deshabilitar scroll
            zoomedCard.style.overflowY = 'hidden'
          }
        })
      }
      
      // Emitir evento de cancelación
      window.dispatchEvent(new CustomEvent('ticket-resolution-cancel', {
        detail: { ticketId: this.ticketIdValue }
      }))
    } else {
      // Expandir
      this.formTarget.classList.remove('hidden')
      this.buttonTextTarget.textContent = 'Cancelar'
      
      // Habilitar scroll del card en móvil cuando el form se expande
      if (zoomedCard && isMobile) {
        zoomedCard.style.setProperty('overflow-y', 'auto', 'important')
        zoomedCard.style.setProperty('overflow-x', 'hidden', 'important')
        zoomedCard.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important')
        zoomedCard.classList.remove('overflow-hidden')
      }
      
      // Inicializar el formulario interno lazy (canvas, etc.)
      setTimeout(() => {
        const formElement = this.formTarget.querySelector('[data-controller*="ticket-resolution-form"]')
        if (formElement) {
          const app = this.application
          const controller = app.getControllerForElementAndIdentifier(formElement, 'ticket-resolution-form')
          if (controller && typeof controller.initializeLazy === 'function') {
            controller.initializeLazy()
          }
        }
        
        // Hacer scroll al formulario después de que se inicialice
        if (zoomedCard && isMobile) {
          // Forzar reflow para que el contenido se renderice
          void zoomedCard.offsetHeight
          
          // Esperar a que el contenido se expanda completamente
          setTimeout(() => {
            // Hacer scroll al formulario dentro de la card zoomed
            this.formTarget.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start',
              inline: 'nearest'
            })
          }, 150)
        } else {
          this.formTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      }, 50)
    }
  }

  close() {
    this.formTarget.classList.add('hidden')
    this.buttonTextTarget.textContent = 'Resolver'
    
    // Emitir evento de cancelación (para volver al mapa si se vino desde allí)
    window.dispatchEvent(new CustomEvent('ticket-resolution-cancel', {
      detail: { ticketId: this.ticketIdValue }
    }))
  }
}
